import { sentByFacet, subjectFacet, recievedDateFacet, folderFacet } from '../Schema/Facets';
import { getParameterStore } from '../store/ParametersStore';
import { displayNameColumn } from '@ms/items-view/lib/private/components/columns/displayName/displayNameColumn';
import { createFacetColumn } from '@ms/items-view/lib/private/components/columns/createColumn';
import { fileTypeIconColumn } from '@ms/items-view/lib/private/components/columns/fileTypeIcon/fileTypeIconColumn';
import { TextField } from '@ms/items-view/lib/private/components/fields/text/TextField';
import { MailboxType } from 'owa-client-ids';

const sentByColumn = createFacetColumn(
    {
        key: 'sentBy',
        name: 'Sent By',
        fieldName: '',
        minWidth: 200,
    },
    {
        sentBy: sentByFacet,
    },
    TextField
)((facets: { sentBy?: typeof sentByFacet.type }) => {
    const sentBy = facets.sentBy;

    return {
        text: sentBy || '',
    };
});

const subjectColumn = createFacetColumn(
    {
        key: 'subject',
        name: 'Subject',
        fieldName: '',
        minWidth: 200,
    },
    {
        subject: subjectFacet,
    },
    TextField
)((facets: { subject?: typeof subjectFacet.type }) => {
    const subject = facets.subject;

    return {
        text: subject || '',
    };
});

const recievedDateColumn = createFacetColumn(
    {
        key: 'recievedDate',
        name: 'Recieved Date',
        fieldName: '',
        minWidth: 200,
    },
    {
        recievedDate: recievedDateFacet,
    },
    TextField
)((facets: { recievedDate?: typeof recievedDateFacet.type }) => {
    const recievedDate = facets.recievedDate;

    return {
        text: `${recievedDate}` || '',
    };
});

const folderColumn = createFacetColumn(
    {
        key: 'folder',
        name: 'Folder',
        fieldName: '',
        minWidth: 200,
    },
    {
        folder: folderFacet,
    },
    TextField
)((facets: { folder?: typeof folderFacet.type }) => {
    const folder = facets.folder;

    return {
        text: folder || '',
    };
});

export function getColumns() {
    const columns = [
        fileTypeIconColumn,
        displayNameColumn,
        sentByColumn,
        subjectColumn,
        recievedDateColumn,
    ];

    const parameterStore = getParameterStore();
    if (parameterStore.mailboxInfo && parameterStore.mailboxInfo.type === MailboxType.UserMailbox) {
        columns.push(folderColumn);
    }

    return columns;
}
